import React, { useEffect, useState } from 'react'
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BasicMenu from './BasicMenu.tsx';
import GetCountUnreadNotification from '../hooks/GetCountUnreadNotification.js';
import GetNotificationWithPayload from '../hooks/GetNotificationWithPayload.js';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationDataState, NotificationState } from '../reduxadmin/Reducers/Interface/Interface.tsx';
import { incrementIndexForNotification, setTotalNotification, totalNotificationAction } from '../reduxadmin/Actions/NotificationAction.tsx';
import { Increment } from '../reduxadmin/Reducers/Interface/Interface.tsx';

const NotificationBell = ({ iconColor }) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const page = 1;
    const size = 5;
    const [flag, setFlag] = useState(true);

    const dispatch = useDispatch();
    const totalNotification = useSelector((state : NotificationState) => state.totalNotification.totalNotification)
    const notificationData = useSelector((state: NotificationDataState) => state.notifications.notifications)
    const index = useSelector((state : Increment) => state.index.index)

    const newNotifications = `You have ${totalNotification} new notifications!`;
    const noNotifications = 'No new notifications';

    let menuShowData = []
    let length = 0
    
    useEffect(()=>{
        load()
    },[totalNotification, notificationData, index])

    const load = async () => {
        const countData = await GetCountUnreadNotification();
        dispatch(totalNotificationAction(countData))
        
    }

    const sendIndexData = () => {
        dispatch(incrementIndexForNotification(index))
        let tmp = index + 1;
        loadNotifications(page, tmp * size, flag)
    }

    const loadNotifications = async  (pageLen, pageSize, flag) => {
        let body = []
        // Clicking on more button
        // if(!flag){
        let arr = [];
        notificationData.map((val, i) => {
            let tmp = {
                ids: val.id
            }
            console.log('happen to be', tmp)
            arr.push(tmp)
        })
        body = arr
        // }

        const data = await GetNotificationWithPayload(pageLen, pageSize, body)
        dispatch(setTotalNotification(data.notificationList))
        setFlag(false)
        
    }

    const handleOpen = async (event) => {
        const body = [];
        const fisrt = true;
        setAnchorEl(event.currentTarget)
        setOpen(true);
        loadNotifications(page, size, flag)
    };
    
    const handleClose = () => {
        console.log('it is happening');
        setOpen(false);
        loadNotifications(page, index * size, flag)
        dispatch(incrementIndexForNotification(1))
        dispatch(setTotalNotification([]))
        dispatch(totalNotificationAction(0))
    };

    return (
        <div>
            <Tooltip title={totalNotification ? newNotifications : noNotifications}>
                <IconButton
                    color={iconColor}
                    onClick={totalNotification ? handleOpen : null}
                    anchorEl={anchorEl}
                >
                    <Badge
                        badgeContent={totalNotification}
                        color="error"
                    >
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </Tooltip>
            <BasicMenu
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
                menuItems={notificationData}
                totalNotification = {totalNotification}
                size = {index * size}
                page = {page}
                sendDataToChild={sendIndexData}
                menuShowData = {menuShowData}
                length={length}
            />
        </div>
    )
}

export default NotificationBell